import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ScienceSection } from './components/ScienceSection';
import { ProductSection } from './components/ProductSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FooterSection } from './components/FooterSection';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="bg-gray-50 font-sans text-lg" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <div className="max-w-4xl mx-auto px-4 pb-12" data-id="element-3">
        <HeroSection data-id="element-4" />
        <StorySection data-id="element-5" />
        <ScienceSection data-id="element-6" />
        <ProductSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
      </div>
      <FooterSection data-id="element-10" />
    </div>;
}